import { createContext, useContext } from 'react';
import { IRaterCoverageListDetailProps } from './rater.coverage.list.detail';
import { IUnderwritingCoverage } from '@converge/graphql';

export interface IRaterCoverageListDetailContextProps
  extends IRaterCoverageListDetailProps {
  updateCoverage: (
    coverage: IUnderwritingCoverage & {
      update: boolean;
    }
  ) => void;
}

export const RaterCoverageListDetailContext =
  createContext<IRaterCoverageListDetailContextProps | null>(null);

export const useRaterCoverageListDetailContext = () => {
  const context = useContext(RaterCoverageListDetailContext);
  if (!context) {
    throw new Error(`This component should be within RaterCoverageListDetail`);
  }
  return context;
};
